import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { Grid, Paper, Tab, Tabs } from '@mui/material';

import { Contacts, Loyalty, CompareArrows, HourglassEmpty } from '@mui/icons-material';

import VendorResellerFetch from './VendorResellerFetch';
import VendorResellerSearch from './VendorResellerSearch';
import VendorResellerPendingSearch from './VendorResellerPendingSearch';
import VendorResellerAnonymousSearch from './VendorResellerAnonymousSearch';
import VendorResellerCrossSellSearch from './VendorResellerCrossSellSearch';

import PageTitle from '../ui/PageTitle';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    // marginTop: 10,
    //backgroundColor: theme.palette.primary.light,
  },
  tabroot: {
    flexGrow: 1,
    margin: 0,
    width: '100%',
    //backgroundColor: theme.palette.primary.light,
    borderBottom: '2px solid #dedede'
  },
  flex: {
    flex: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'left',
    color: theme.palette.text.secondary,
    maxWidth: 1200,
    marginTop: 16,
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  tabScrollButton:{
    flex: '0 0 0px'
  },

  /* Hidden below is sort of a hack.  Without overflow hidden - scroll bars appear but were not revealing 
  more data.  It was not obvious what is causing it.  Needs more research */

  /* Screen size specific styles */
  [theme.breakpoints.up('xs')]: {
    tabContainer: {
      padding: 0,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: 'xx-small',
    },
    labelContainer: {
      paddingLeft: 4,
      paddingRight: 4,
    },
    label: {
      fontSize: 'xx-small',
    },
    labelWrapped: {
      fontSize: 'xx-small',
    },
  }
  ,
  [theme.breakpoints.up('sm')]: {
    tabContainer: {
      padding: 8,
      overflow: 'hidden'
    },

    /* Tab navigation */
    tab: {
      fontSize: 'x-small',
    },
    labelContainer: {
      paddingLeft: 8,
      paddingRight: 8,
    },
    label: {
      fontSize: 'x-small',
    },
    labelWrapped: {
      fontSize: 'x-small',
    },
  },
  [theme.breakpoints.up('md')]: {
    tabContainer: {
      padding: 20,
      overflow: 'hidden'
    },
  
    /* Tab navigation */
    tab: {
      fontSize: '0.75rem',
    },
    labelContainer: {
      paddingLeft: 12,
      paddingRight: 12,
    },
    label: {
      fontSize: '0.75rem',
    },
    labelWrapped: {
      fontSize: '0.75rem',
    },
  }
});

function TabContainer(props) {
  const classes = props.classes;
  return <div className={classes.tabContainer}>{props.children}</div>;
}

class VendorReseller extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: 0
    }
  }

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) { window.analytics.page(); }

    let accountId = abEnvironment.getUserAttribute("a_id");

    VendorResellerFetch.fetch(accountId).toPromise()
    .then(vrf => {
      let allVppTs = vrf.allVppTs;

      let allAccountRelationTs = vrf.allAccountRelationTs;
 
      if (allVppTs.nodes[0] && allVppTs.nodes[0].vppRTsByVppId.totalCount > 0) {
        //if there is 1 pending / applied reseller, place them on that tab
        this.setState({value: 1});
      } else if (allAccountRelationTs.totalCount > 0) {
        //if there is 1 or more registered resellers, place them on that tab
        this.setState({value: 2});
      } else {
        this.setState({value: 0});
      }

    })
    .catch(err => {
       //alert('Error: ' + err);
    });

  }

  handleTabChange = (event, value) => {
    this.setState({ value });
  }

  setTabValue = (tv) => {
    this.setState({value: tv});
  }

  goTo(route) {
     this.props.history.push(`/${route}`);
  }
 
  
  render() {
    const { isAuthenticated, isAuthenticatedAppBind, isAuthenticatedVendor, needAssent } = this.props.auth;
    const classes = this.props.classes;
    const { value } = this.state;


    if (!isAuthenticated() || needAssent()) {
      return (
        <Redirect to='/home' />
      );
    } else if (isAuthenticatedVendor() || isAuthenticatedAppBind()) {

      return (
        <div className={classes.root}>
          <PageTitle title="Partners" subtitle="Partners who have billed subscriptions."/>

          <Paper className={classes.paper}>

            <Grid container spacing={0} direction="row" justifyContent="space-around">

              <Grid item xs={12}>
                <Tabs
                  value={value}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  scrollButtons="auto"
                  classes={{root: classes.tabroot, scrollButtons: classes.tabScrollButton}}
                >
                  <Tab label="Anonymous" icon={<Contacts />}
                    classes={{
                        root: classes.tab,
                        wrapper: classes.labelWrapped,
                      }}
                  />
                  <Tab label="Pending" icon={<HourglassEmpty />}
                    classes={{
                      root: classes.tab,
                      wrapper: classes.labelWrapped,
                    }}
                  />
                  <Tab label="Registered" icon={<Loyalty />}
                    classes={{
                      root: classes.tab,
                      wrapper: classes.labelWrapped,
                    }}
                  />
                  <Tab label="Cross Sell" icon={<CompareArrows />}
                    classes={{
                      root: classes.tab,
                      wrapper: classes.labelWrapped,
                    }}
                  />
                </Tabs>
              </Grid>
              <Grid item xs={12} style={{marginTop: '10px'}}>
                {value === 0 &&
                  <TabContainer {...this.props}>
                    <VendorResellerAnonymousSearch 
                        auth={this.props.auth}
                        history={this.props.history}
                    />
                  </TabContainer>
                }
                {value === 1 &&
                  <TabContainer {...this.props}>
                    <VendorResellerPendingSearch 
                        auth={this.props.auth}
                        history={this.props.history}
                    />
                  </TabContainer>
                }
                {value === 2 &&
                  <TabContainer {...this.props}>
                    <VendorResellerSearch 
                        auth={this.props.auth}
                        history={this.props.history}
                    />
                  </TabContainer>
                }
                {value === 3 &&
                  <TabContainer {...this.props}>
                    <VendorResellerCrossSellSearch 
                        auth={this.props.auth}
                        history={this.props.history}
                    />
                  </TabContainer>
                }
              </Grid>

            </Grid>

          </Paper>
        </div>
      )

    } else {
        return (
        <h4>
          You do not have access to this page.
        </h4>
      );
    }
  }


}

VendorReseller.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(VendorReseller);
